
import { useReportQuery } from "./useReportQuery";
import { useFilterActions } from "./useFilterActions";
import { usePrefetchAdjacent } from "./usePrefetchAdjacent";
import { useErrorHandler } from "./useErrorHandler";
import { UseReportFiltersProps, ReportFiltersResult } from "./types";

export const useReportFilters = ({
  searchTerm,
  queryClient,
  toast,
  initialFilters = {},
  pageSize = 6
}: UseReportFiltersProps): ReportFiltersResult => {
  // Use our custom hooks
  const {
    selectedCategory,
    setSelectedCategory,
    sortBy,
    setSortBy,
    sortOrder,
    setSortOrder,
    currentPage,
    setCurrentPage,
    itemsPerPage,
    setItemsPerPage,
    isHovering,
    filterState,
    handleCategoryChange,
    handleSortChange,
    handleItemsPerPageChange,
    handlePaginationHover
  } = useFilterActions({ ...initialFilters, pageSize });

  // Query the reports
  const { queryResult, filteredReports, totalPages } = useReportQuery(
    searchTerm,
    filterState,
    toast
  );

  // Prefetch adjacent pages
  usePrefetchAdjacent(
    queryClient, 
    filterState, 
    searchTerm,
    queryResult.isLoading,
    queryResult.data
  );

  // Handle errors
  useErrorHandler(queryResult.error, toast);

  // Return everything needed from our hooks
  return {
    selectedCategory,
    setSelectedCategory,
    sortBy,
    setSortBy,
    sortOrder,
    setSortOrder,
    currentPage,
    setCurrentPage,
    itemsPerPage,
    setItemsPerPage,
    handleCategoryChange,
    handleSortChange,
    handleItemsPerPageChange,
    handlePaginationHover,
    data: queryResult,
    isLoading: queryResult.isLoading,
    filteredReports,
    totalPages,
    error: queryResult.error
  };
};
